<template>
  <div class="wrap">
    <div class="input-wrap">
      <input
        type="number"
        inputmode="decimal"
        class="input number-input"
        ref="valueInput"
        :disabled="disabled"
        :value="actualValue.number"
        @input="onInput"
        :placeholder="$t('ieo.trade.placeholder')"
      />
      <!-- 포커스 아웃일 때 @blur="validateFinal" -->
      <div class="input-x-btn-wrap" @click="!disabled && changeValue(0)"></div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Decimal from "decimal.js";

export default {
  props: {
    value: {
      default: 0,
      // type: Number
    },
    // btn: {
    //   default: true,
    //   type: Boolean,
    // },
    // btn1: {
    //   default: "arrow-up",
    //   type: String,
    // },
    // btn2: {
    //   default: "arrow-down",
    //   type: String,
    // },
    // currency: {
    //   default: "KRW",
    //   type: String,
    // },
    // step: {
    //   default: 0.000001,
    //   type: [Number, String],
    // },
    disabled: {
      default: false,
      type: Boolean,
    },
    decimal: {
      default: 0,
      type: Number,
    },
    // override: {
    //   default: false,
    //   type: [Boolean, String],
    // },
    // min: {
    //   default: 0,
    //   type: Number,
    // },
    // max: {
    //   default: Infinity,
    //   type: Number,
    // },
    nagative: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      actualValue: {
        number: "",
        string: "",
      },
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.actualValue.string;
      },
      set(val) {
        this.actualValue = {
          number: val,
          string: val,
          // number: this.unFormatNumber(val),
          // string: this.formatNumber(val),
        };
      },
    },
  },
  methods: {
    changeValue(n) {
      let numberString = n.toString();

      // check if expotential
      if (~numberString.indexOf("e-")) {
        const parts = numberString.split("e-");
        numberString = n.toFixed(parts[parts.length - 1]);
      }

      // validation
      const _regex = this.negative ? /[^\d\.\-]/g : /[^\d\.]/g;
      numberString = numberString.replace(_regex, "");

      this.inputValue = numberString || 0;
      this.$emit("input", this.actualValue.number);
    },
    onInput(e) {
      this.changeValue(e.target.value);
    },
    formatNumber(val) {
      if (!val) {
        return "";
      }
      // 정수와 소수부를 나눈다
      let [integer, fraction] = val.toString().split(".");
      integer = this.unFormatNumber(integer);
      integer = Intl.NumberFormat("en").format(integer);
      return typeof fraction !== "undefined" && this.decimal
        ? `${integer}.${fraction.substr(0, this.decimal)}`
        : integer;
    },
    unFormatNumber(str) {
      if (typeof str === "number") {
        return str;
      }
      const unFormattedNumber = parseFloat(str.replace(/,/g, ""));
      // safe integer check
      if (isNaN(unFormattedNumber)) {
        str = "0";
      } else if (!Number.isSafeInteger(parseInt(unFormattedNumber))) {
        return Number.MAX_SAFE_INTEGER;
      }
      // return parseFloat(str.replace(/,/g, ""));
      return new Decimal(unFormattedNumber)
        .toFixed(8, Decimal.ROUND_DOWN)
        .toString();
    },
    // validateFinal() {
    //   let finalValue = this.actualValue.number;
    //   finalValue = _.clamp(finalValue, this.min, this.max);

    //   this.changeValue(finalValue);
    // }
  },
  watch: {
    value(v) {
      if (v !== this.actualValue.number) {
        this.changeValue(v);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  display: table;
  width: 100%;
}
.input-wrap {
  width: 200px;
  display: table-cell;
  position: relative;
}
.input {
  box-sizing: border-box;
  width: 100%;
  height: 32px;
  padding-right: 10px;
  font-size: 16px;
  letter-spacing: 0.5px;
  text-align: right;
  border: none;
  &::placeholder {
    opacity: 0.5;
    font-size: 14px;
  }
}
.input-x-btn-wrap {
  top: 0px;
  right: 0px;
  line-height: 32px;
  font-size: 14px;
  padding: 0px 4px;
  position: absolute;
  vertical-align: middle;
  cursor: pointer;
}

.input-btn {
  width: 30px;
  text-align: center;
  background-color: #f0f0f0;
  border: solid 1px #d0d5da;
  border-left: none;
  display: table-cell;
  cursor: pointer;
}
.input-btn i {
  font-weight: bold;
  vertical-align: middle;
}
.input-btn:active {
  color: #246ec0;
  background-color: #cdcdcd;
}

/* .currency {
  padding-left: 7px;
  color: #000000;
  display: table-cell;
} */
</style>
